module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Loyal to the Sky")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "CSS_1.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d14e223"
    }
  }, [_c('h1', {
    attrs: {
      "id": "d7e67516"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e68016"
    }
  }, [_c('br'), _vm._v(" Indeed it takes a village, and in this case, a global one.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e68716"
    }
  }, [_vm._v("First and foremost, thank you to the millions of people across the planet working to make their communities and this earth a better place. Your dedication and love are changing the world in ways visible and yet to unfold. You are the inspiration for this book and our hope for the future.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e70616"
    }
  }, [_vm._v("It has been a great honor to have as my editor Johanna Vondeling, without whom this book wouldn’t exist and would most certainly not be what it is today. Her insights and vision were transformative. Her dedication and patience were awe-inspiring. Also great gratitude to all the incredible staff at Berrett-Koehler for their enthusiasm, expertise, and commitment to a better world. My thanks as well to Amy Einsohn, my copyeditor, for polishing this book with such a keen eye.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e73416"
    }
  }, [_vm._v("I am particularly grateful to my sister Gabrielle Handler Marks and my brother-in-law Donald Marks, who have been a constant source of support and generosity.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e74816"
    }
  }, [_vm._v("Thank you to my own community, the San Francisco Buddhist Alliance for Social Engagement household, which has stood by me with support and encouragement throughout the creation of this book. Scott Boultinghouse, Diane Gregorio, and Hugo Medina: each of you has reminded me on a daily basis what it means to live with wisdom and compassion.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e77316"
    }
  }, [_vm._v("I am deeply indebted to Michael Lerner, Michael Nagler, and Sharif Abdullah, each of whom has mentored me at a crucial phase in my own development, and whose lives stand as towering examples of courage and vision.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e78916"
    }
  }, [_vm._v("My huge gratitude to my parents for their love and support, and to my brother Marc Handler for his humor and faith in me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e79916"
    }
  }, [_vm._v("Much appreciation to my friends from Code Orange, who have been inimitable "), _c('i', [_vm._v("compañeros")]), _vm._v(" and judicious teachers along this path.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e81717"
    }
  }, [_vm._v("My thanks to Nina and Trevor Blanc and to Noa Marks, who masterfully fulfilled the often-demanding task of keeping me silly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e82717"
    }
  }, [_vm._v("Thank you to Peter Barnes and the Mesa Refuge, for the gift of time and space to simply write.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e83717"
    }
  }, [_vm._v("For numerous forms of support, I am indebted to Nancy Shaw, Elizabeth Zarek, Rebecca Solnit, David Solnit, Rachael Cunningham, Eddie Foronda, and Jonathan Raymond.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "d7e85017"
    }
  }, [_vm._v("For advice and encouragement, I am very grateful to Christopher Cook, Nicole Monastersky Maderas, Caryn Mandelbaum, Hannah Acevedo-Schiesel, Danielle Monastersky, Remi Cohen, Darren Noy, Jo Ellen Green Kaiser, Michael Chorost, and Mark Abel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-313efe6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 81
// module chunks = 0